import Cookies from 'js-cookie';

const currentPortal = process.env.REACT_APP_BUILD_SITE;
const portalsWithEcommerce = ['ZPAR', 'WIBR', 'IWBR', 'UBPE', 'DVPE', '24MX', 'PLEC', 'CAPA', 'CMBR', 'VAMX'];

export function termsAndConditionsBySite() {
  const portales = {
    ZPAR: 'https://help.zonaprop.com.ar/kb/es/article/terminos-y-condiciones-generales-de-contratacion',
    WIBR: 'https://help.imovelweb.com.br/pt-BR/articles/3499984-termos-e-condicoes-gerais-de-contratacao',
    UBPE: 'https://help.urbania.pe/es/articles/3633657-contacto',
    IWBR: 'https://help.imovelweb.com.br/pt-BR/articles/3494547-termos-e-condicoes-gerais-de-contratacao',
    DVPE: 'https://help.adondevivir.com/es/articles/3479216-terminos-y-condiciones-generales-de-contratacion',
    '24MX':
      'https://help.inmuebles24.com/kb/es/article/t%C3%A9rminos-y-condiciones-generales-de-contrataci%C3%B3n-del-portal',
    LLVE: 'https://www.conlallave.com/terminos.bum',
    PLEC: 'https://help.plusvalia.com/kb/es/article/terminos-y-condiciones-generales-de-contratacion',
    CAPA: 'https://help.compreoalquile.com/es/articles/4119772-terminos-y-condiciones-generales-de-contratacion',
    VAMX:
      'https://help.vivanuncios.com.mx/kb/es/article/t%C3%A9rminos-y-condiciones-generales-de-contrataci%C3%B3n-del-portal'
  };
  return portales[currentPortal];
}

/**
 * Validate portals with ecommerce
 * return {boolean} Have or not ecommerce
 */
export const isPortalWithEcommerce = portalsWithEcommerce.includes(currentPortal);

/**
 * La función evalúa si la url ya tiene o no un parámetro para añadir un '&' ó '?'
 * @param {string} path - url completa a la que se la va agregar el parámetro
 * @param {string} param - parámetro a agregar Ej: ref=zonademand
 * @returns {string} - retorna la url con el parámetro
 */
export function addUrlParam(path, param) {
  if (!path || !param) return path;
  return path.concat(`${path.includes('?') ? '&' : '?'}${param}`);
}

/**
 * Función para redirecciones a publicar.bum que evalúa si existe la cookie 'showOldReppro'
 * y concatena el parámetro correspondiente para mostrar el publicador anterior.
 * @param {string} baseUrl - URL base de publicar.bum (ej: '/publicarPasoDatosPrincipales.bum')
 * @returns {string} - URL con el parámetro showOldReppro=true si la cookie está seteada
 */
export function getPublishUrlWithOldRepproParam(baseUrl) {
  if (!baseUrl) return '';

  const showOldRepproCookie = Cookies.get('showOldReppro');

  // Verificar si la cookie existe y tiene el valor 'true'
  if (showOldRepproCookie === 'true') {
    return addUrlParam(baseUrl, 'showOldReppro=true');
  }

  return baseUrl;
}

/**
 * Función helper para redireccionar directamente a publicar.bum con el parámetro showOldReppro si aplica
 * @param {string} baseUrl - URL base de publicar.bum (ej: '/publicarPasoDatosPrincipales.bum')
 */
export function redirectToPublishWithOldReppro(baseUrl) {
  const finalUrl = getPublishUrlWithOldRepproParam(baseUrl);
  window.location.href = finalUrl;
}

export function ecommerceSites(publisherTypeId, postingId) {
  const portales = {
    ZPAR: '/publica-tu-propiedad',
    WIBR: '/anuncie-seu-imovel',
    UBPE: '/publica-tu-aviso',
    IWBR: '/anuncie-seu-imovel',
    ICBR: '/anuncie-seu-imovel',
    DVPE: '/publica-tu-propiedad',
    '24MX': '/publica-tu-propiedad',
    CAPA: '/publica-tu-propiedad',
    PLEC: '/publica-tu-propiedad',
    VAMX: '/publica-tu-propiedad'
  };

  const isParticular = publisherTypeId === '1';
  const profesional = ['WIBR', 'IWBR', 'ICBR'].includes(currentPortal) ? '/profissional.html' : '/profesional.html';

  if (!isPortalWithEcommerce) return null;
  // validacion para ecommerce de casamineira
  if (currentPortal === 'CMBR') return '/melhoresplanos';

  return isParticular
    ? `/panel/publicador/planes/seleccion?postingId=${postingId}`
    : `${portales[currentPortal]}${profesional}`;
}

/**
 * La función devuelve los search params que se concatenarán en la url del redirect.
 * @param {object} paramsObject Objeto que contiene todos elementos de los search params. Ej: { avisos: [{ key: 'portal', value: 'zonaprop'}]}
 * @param {string} source key para acceder al array dentro del objeto que contiene los search params. Ej: 'avisos'
 * @returns string con los search params. Ej: urlBaseDeEjemplo?portal=zonaprop
 */
export function getSearchParams(paramsObject, source) {
  const fullParams = new URLSearchParams();
  const sourceParams = paramsObject[source];
  sourceParams.map(param => param.value && fullParams.set(param.key, param.value));
  return fullParams.toString();
}
